// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"palace-4"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 5.5V21H3V5.5L6 3L9 5.5V10H15V5.5L18 3L21 5.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10 21V17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17V21H10Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 21V17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17V21H10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 10V21H21V10M3 10V5.5L6 3L9 5.5V10M3 10H9M21 10V5.5L18 3L15 5.5V10M21 10H15M9 10H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Palace4Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'palace-4',
    ref,
    icon: element,
  },
));

Palace4Icon.displayName = 'Palace4Icon';

export default Palace4Icon;
